import { TestRowSharedType } from '../helpers/types';
import { MODAL_ACTION_ACTIONS, MODAL_ACTION_TITLES } from '../labels';

import { LABEL_MANAGEMENT_MODAL_TYPE } from './constants';
import { LabelManagementModalType } from './LabelManagementSharedModal.types';

export const baseGetModalTitle = (
	modalType: LabelManagementModalType,
	testRows: TestRowSharedType[]
): string => {
	const actionTitle = MODAL_ACTION_TITLES[modalType];

	if (!testRows || testRows.length === 0) {
		return actionTitle;
	}

	if (testRows.length === 1) {
		const testRow = testRows[0];
		const testName =
			testRow?.testName ||
			testRow?.sessionName ||
			(testRow as { testDisplayName?: string })?.testDisplayName;

		const truncatedTestName =
			testName?.length > 50 ? `${testName.slice(0, 50)}...` : (testName ?? '');

		const action = MODAL_ACTION_ACTIONS[modalType];
		return truncatedTestName ? `${actionTitle} ${action} ${truncatedTestName}` : actionTitle;
	}

	let action = 'for';
	if (modalType === LABEL_MANAGEMENT_MODAL_TYPE.ADD) {
		action = 'to';
	} else if (modalType === LABEL_MANAGEMENT_MODAL_TYPE.REMOVE) {
		action = 'from';
	}
	return `${actionTitle} ${action} ${testRows.length} tests`;
};
